import { call, put } from 'redux-saga/effects'

import { type InboxActions, InternalInboxActions } from '../actions'
import { inboxClient } from '../client'
import type { InboxPage } from '../types'

// The unread rows come as one list; a failure here is silent, the badge
// poll will report the count anyway
export function* fetchFresh({
  payload: { workspace },
}: ReturnType<typeof InboxActions.fetchFresh>) {
  try {
    const page: InboxPage = yield call(inboxClient.fresh, workspace)

    yield put(InternalInboxActions.freshLoaded({ workspace, page }))
  } catch (error) {
    console.error('Error fetching unread activity:', error)
  }
}
